import parsePhoneNumber from 'libphonenumber-js'

export interface ParsedPhoneNumber {
  country: string
  nationalNumber: string
  number: string
}

class PhoneNumberHelper {
  parsePhoneNumber(phoneNumber: string) {
    return parsePhoneNumber(phoneNumber) as ParsedPhoneNumber
  }
}

export default new PhoneNumberHelper()
